import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';

import AddDetail from './AddDetail';
import EditDetail from './EditDetail';

const styles = {
    icon: { iconStyle: { color: '#00bcd4' } },
};

const Details = ({ 
    details,
    onAdd,
    onEdit,
    onDelete,
    name,
    min,
    max,
}) => {
    const [dialogState, setDialogState] = useState({
        openEditDialog: false,
        openAddDialog: false,
        current: {
            detail: null,
            index: -1,
        },
    });

    const toggleAddDialog = useCallback(() => {
        setDialogState(prev => ({
            ...prev,
            openAddDialog: !prev.openAddDialog,
        }));
    }, []);

    const toggleEditDialog = useCallback((detail = null, index = -1) => {
        setDialogState(prev => ({
            ...prev,
            openEditDialog: !prev.openEditDialog,
            current: { detail, index },
        }));
    }, []);

    const handleAdd = useCallback((newDetail) => {
        onAdd(newDetail);
        toggleAddDialog();
    }, [onAdd, toggleAddDialog]);

    const handleEdit = useCallback((editedDetail) => {
        onEdit(editedDetail, dialogState.current.index);
        toggleEditDialog();
    }, [onEdit, toggleEditDialog]);

    const { openEditDialog, openAddDialog, current } = dialogState;

    return (
        <React.Fragment>
            {details.map((detail, index) => (
                <React.Fragment key={index}>
                    <div className='item middle-xs'>
                        <div className='count'>
                            {detail.value} mt
                        </div>

                        <div className='name'>
                            {detail.name}
                        </div>

                        <div className='edit'>
                            <div className='icon edit-icon'>
                                <IconButton
                                    iconStyle={styles.icon.iconStyle}
                                    onClick={() => toggleEditDialog(detail, index)}
                                >
                                    <CreateIcon />
                                </IconButton>
                            </div>

                            <div className='icon delete-icon'>
                                <IconButton
                                    iconStyle={styles.icon.iconStyle}
                                    onClick={() => onDelete(index)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ))}

            <AddDetail
                open={openAddDialog}
                onClose={toggleAddDialog}
                onSubmit={handleAdd}
                name={name}
                min={min}
                max={max}
            />

            <EditDetail
                open={openEditDialog}
                onClose={toggleEditDialog}
                onSubmit={handleEdit}
                detail={current.detail}
                name={name}
                min={min}
                max={max}
            />

            <div className='row add-capacity'>
                <div className='col-xs-9' />
                <div className='col-xs-3 middle-xs end-xs'>
                    <div className='text'>Add capacity</div>
                    <IconButton
                        iconStyle={styles.icon.iconStyle}
                        onClick={toggleAddDialog}
                    >
                        <ControlPointIcon />
                    </IconButton>
                </div>
            </div>
        </React.Fragment>
    );
};

Details.propTypes = {
    details: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })).isRequired,
    onAdd: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
};

export default Details;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/Details.jsx